const PATH = process.env.PUBLIC_URL;

export const images = {
    Map: PATH + '/assets/img/location.png',
    사과대: PATH + '/assets/img/사과대.png',
    공대: PATH + '/assets/img/공대.png',
    글경대: PATH + '/assets/img/글경대.png',
    사범대: PATH + '/assets/img/사범대.png',
    예대: PATH + '/assets/img/예대.png',
    인문대: PATH + '/assets/img/인문대.png',
    신대: PATH + '/assets/img/신대.png',
    LikelionLogo: PATH + '/assets/img/logo/likelionLogo.png',
    선관위: PATH + '/assets/img/logo/선관위.png',
    Pagetitle: PATH + '/assets/img/Pagetitle.png',
    
    // 보궐선거
    "Bymap": PATH + '/assets/img/byImg/Bymap1.png',
    "BymapBottom": PATH + '/assets/img/byImg/BymapBottom.png'
};